import { theme } from "../../../config";
import { Label } from "../../atoms/Label";
import { Select } from "../../atoms/Select";
import { OptionItemWithInput } from "../../molecules/OptionItemWithInput";
import { FailedReasonWrapped } from "../../templates/ApplicantDetails/elements";
import { ApplicantDetailsModalFooter } from "../ApplicantDetailsModalFooter";
import { MoveApplicantStatusDetails } from "../MoveApplicantStatusDetails";
import { Select as AntSelect } from "antd";
import { FailedApplicantModalBodyProps } from "./types";

const FailedApplicantModalBody = ({
  applicantName,
  subStatus,
  currentStatus,
  phaseKey,
  isInitialsReasonSelected,
  handleSelectChange,
  placeholder,
  failedReasonsData,
  customReason,
  handleInputChange,
  handlePressEnter,
  otherReasonErrorMessage,
  failedReason,
  onModalConfirm,
  onModalCancel,
}: FailedApplicantModalBodyProps) => {
  const { Option } = AntSelect;
  return (
    <>
      <MoveApplicantStatusDetails
        isHoverable={false}
        applicantName={applicantName}
        tag1Color={theme.colors.custom.darkblue1}
        tag1Text={subStatus || currentStatus}
        tag2Color={
          phaseKey === "Failed"
            ? theme.colors.utilities.error
            : theme.colors.custom.darkblue3
        }
        tag2Text={phaseKey}
      />
      {phaseKey === "Failed" && (
        <FailedReasonWrapped>
          <Label
            style={{
              fontSize: "14px",
              color: "#767676",
            }}
          >
            {isInitialsReasonSelected ? "Reason" : "Other"}
          </Label>
          <Select
            onMouseDown={(event: any) => {
              event.preventDefault();
              event.stopPropagation();
            }}
            handleChange={handleSelectChange}
            placeholder={placeholder}
            optionItems={
              <>
                {failedReasonsData.map((status: string) => (
                  <>
                    <Option
                      key={status}
                      value={status}
                      style={{ width: "100%" }}
                    >
                      {status}
                    </Option>
                  </>
                ))}
              </>
            }
            inputItems={
              <OptionItemWithInput
                label="Others"
                value={customReason}
                handleChange={handleInputChange}
                onPressEnter={handlePressEnter}
                inputError={otherReasonErrorMessage}
              />
            }
          />
        </FailedReasonWrapped>
      )}
      <ApplicantDetailsModalFooter
        disableConfirm={phaseKey === "Failed" && !failedReason}
        onConfirm={onModalConfirm}
        onCancel={onModalCancel}
      />
    </>
  );
};

export default FailedApplicantModalBody;
